/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.14.0
// source: proto/admpb/errormsg.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.admpb = require('./errormsg_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.ErrorMsgServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.ErrorMsgServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.SendErrorMsgRequest,
 *   !proto.admpb.SendErrorMsgResponse>}
 */
const methodDescriptor_ErrorMsgService_SendErrorMsg = new grpc.web.MethodDescriptor(
  '/admpb.ErrorMsgService/SendErrorMsg',
  grpc.web.MethodType.UNARY,
  proto.admpb.SendErrorMsgRequest,
  proto.admpb.SendErrorMsgResponse,
  /**
   * @param {!proto.admpb.SendErrorMsgRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.SendErrorMsgResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.SendErrorMsgRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.SendErrorMsgResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.SendErrorMsgResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.ErrorMsgServiceClient.prototype.sendErrorMsg =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.ErrorMsgService/SendErrorMsg',
      request,
      metadata || {},
      methodDescriptor_ErrorMsgService_SendErrorMsg,
      callback);
};


/**
 * @param {!proto.admpb.SendErrorMsgRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.SendErrorMsgResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.ErrorMsgServicePromiseClient.prototype.sendErrorMsg =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.ErrorMsgService/SendErrorMsg',
      request,
      metadata || {},
      methodDescriptor_ErrorMsgService_SendErrorMsg);
};


module.exports = proto.admpb;

